import mitt from 'mitt';

/**
 * @typedef {import('bto-models/event-bus/interfaces').TEventBusEvents} TEventBusEvents
 * @typedef {import('bto-models/event-bus/interfaces').Emitter<TEventBusEvents>} Emitter
 * 
 */

/**
 * Initialize mitt to work like Vue event bus
 * @returns {Emitter}
 */
function getEventBus() {
  const eventBus = mitt();
  eventBus.$on = eventBus.on;
  eventBus.$off = eventBus.off;
  eventBus.$emit = eventBus.emit;
  eventBus.once = (key, handler) => {
    const unwatch = (args) => {
      eventBus.off(key, unwatch);
      handler(args);
    }
    eventBus.on(key, unwatch);
  };
  eventBus.$once = eventBus.once;
  return eventBus;
}

/**
 * 
 * @returns {import('bto-models/event-bus/interfaces').TBtoBusEmitter}
 */
function getExternalEventBus() {
  const eb = getEventBus();
  const oemit = eb.emit;
  eb.emit = (type, event) => {
    window.parent.postMessage({
      __btoInternal: true,
      btoEvent: true,
      type,
      event,
    }, '*');
    oemit(type, event);
  };
  eb.$emit = eb.emit;
  eb._iemit = oemit;
  return eb;
}

/**
 * Internal Event bus
 */
export const EVENT_BUS = getEventBus();
/**
 * External Event bus
 */
export const BTO_EVENT_BUS = getExternalEventBus();

/**
 * Handler for two way comunication, using message events 
 * @param {MessageEvent} ev - global message event
 */
const handleBtoMessages = (ev) => {
  const data = ev.data;
  if (!data || data.__btoInternal || !data.btoEvent) {
    return;
  }
  BTO_EVENT_BUS._iemit(data.type, data.event);
}

export const initBtoPublicBus = () => {
  /**
   * @type {typeof BTO_EVENT_BUS}
   */
  const busQueue = window['btoEventBus'];
  if (busQueue && busQueue.q) {
    busQueue.q.forEach(e => {
      switch (e.f) {
        case 'emit':
          BTO_EVENT_BUS.emit(...e.args);
          break;
        case 'on':
          BTO_EVENT_BUS.on(...e.args);
          break;
        case 'off':
          BTO_EVENT_BUS.off(...e.args);
          break;
      }
    });
  }
  window['btoEventBus'] = BTO_EVENT_BUS;
  window.addEventListener('message', handleBtoMessages);
};